import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  scrollBehavior() {
    return { x: 0, y: 0 }
  },
  routes: [
    {
      path: '/about',
      name: 'about',
      component: () => import('@/views/Home/Home.vue'),
      meta: {
        title: '私服123 - 天堂私服123/天堂/私服/私服123/天堂123',
        layout: 'full',
      },
    },
    {
      path: '*',
      redirect: { name: 'about' },
    },
    // {
    //   path: '/error-404',
    //   name: 'error-404',
    //   component: () => import('@/views/error/Error404.vue'),
    //   meta: {
    //     layout: 'full',
    //   },
    // },
  ],
})

// ? For splash screen
// Remove afterEach hook if you are not using splash screen
router.afterEach(() => {
  // Remove initial loading
  const appLoading = document.getElementById('loading-bg')
  if (appLoading) {
    appLoading.style.display = 'none'
  }
})

export default router
